import React from "react";
import { Form, Input, Button, Row, Col } from "antd";
import "./ApplicationStatus.css";

const ApplicationStatus: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form submitted:", values);
    // Handle form submission logic here
  };

  return (
    <div className="application-status-page">
      <div className="status-content-wrapper">
        <Row gutter={20}>
          <Col xs={24} lg={10}>
            <div className="status-form-card">
              <h1 className="status-title">Check Application Status</h1>
              <p className="status-description">
                Complete the form below to check the status of your application.
                If your application was approved, you may also use this form to
                retrieve your incentive code.
                <br />
                You must use the same email address and phone number that were
                submitted with your application.
              </p>
              <div className="status-divider"></div>

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className="status-form"
              >
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[
                    { required: true, message: "Please enter your last name" },
                  ]}
                >
                  <Input placeholder="" className="status-input" />
                </Form.Item>

                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your phone number",
                    },
                  ]}
                >
                  <Input placeholder="" className="status-input" />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input placeholder="" className="status-input" />
                </Form.Item>

                <Form.Item className="submit-button-container">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="status-submit-button"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="status-image-container">
              <img
                src="/images/application-status-hero.webp"
                alt="Cyclist in urban environment"
                className="status-hero-image"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ApplicationStatus;
